// 如果在Node.js中，需要引入fetch
// import fetch from 'node-fetch';

import { DEFAULT_RPC } from "@/config";

/**
 * 计算RPC请求的延迟时间。
 * @param url RPC服务器的URL。
 * @param method 请求使用的方法，通常是'POST'。
 * @param body 请求的主体，通常为JSON字符串。
 * @returns 返回延迟时间（毫秒）。
 */
async function measureRpcLatency(
  url: string,
  method: string = "POST",
  body: string
): Promise<number> {
  const headers = {
    "Content-Type": "application/json",
  };

  const start = performance.now(); // 记录请求开始时间

  try {
    const response = await fetch(url, {
      method: method,
      headers: headers,
      body: body,
    });

    if (!response.ok) {
      throw new Error("RPC request failed with status " + response.status);
    }

    const end = performance.now(); // 记录响应结束时间
    return end - start; // 计算并返回延迟时间
  } catch (error) {
    console.error("Error during RPC request:", error);
    throw error; // 将错误抛出，让调用者处理
  }
}

// 使用方法示例
export async function testRpcLatency(
  url: any = "",
  json: any = {
    jsonrpc: "2.0",
    method: "eth_blockNumber",
    params: [],
    id: 1,
  }
) {
  const requestBody = JSON.stringify(json);

  try {
    const latency = await measureRpcLatency(url, "POST", requestBody);
    // console.log(`The RPC：${url} call latency was ${latency} ms.`);
    return Math.ceil(latency);
  } catch (error) {
    console.error("Failed to measure RPC latency:", error);
  }
  return false;
}

export function getLocRpc() {
  return window.localStorage.getItem("suiRpc") || DEFAULT_RPC;
}

export function setLocStorageRpc(url: any = "") {
  window.localStorage.setItem("suiRpc", url);
}

export function getLocCus() {
  return window.localStorage.getItem("suiCusRpc") || "{}";
}

export function setLocCus(cus: any = {}) {
  const str = JSON.stringify(cus);
  window.localStorage.setItem("suiCusRpc", str);
}

export async function pingUrl(url: string): Promise<number> {
  const startTime = performance.now(); // 记录请求开始的时间
  try {
    const response: any = await fetch(url, { mode: "no-cors" }); // 使用 no-cors 模式来避免跨域问题
    const endTime = performance.now(); // 记录请求结束的时间
    const latency = endTime - startTime; // 计算延迟
    return latency; // 返回延迟时间
  } catch (error) {
    console.error("Ping error:", error);
    throw new Error("Failed to ping URL"); // 抛出错误
  }
}
